export default "__VITE_ASSET__Bwpf19SB__"